import { render, staticRenderFns } from "./PrivacyStatementComponent.vue?vue&type=template&id=4ab29c9c&scoped=true&"
import script from "./PrivacyStatementComponent.vue?vue&type=script&lang=js&"
export * from "./PrivacyStatementComponent.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyStatementComponent.vue?vue&type=style&index=0&id=4ab29c9c&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab29c9c",
  null
  
)

export default component.exports